import moment from 'moment'

import { apiClient } from '@/services/ApiClient.js'
import country from '@/utilities/country'

export default {
  getFinancingCostSummaries(query) {
    return apiClient
      .get('financing-cost-summary', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getFinancingCostSummary(id) {
    return apiClient
      .get('financing-cost-summary/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteFinancingCostSummary(id) {
    return apiClient
      .delete('financing-cost-summary/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createFinancingCostSummary(form) {
    let formData = new FormData()

    if (form.file) {
      formData.append('file', form.file)
    }

    let body = JSON.stringify({
      bank_id: form.bank_id,
      promissory_note_reason: form.promissory_note_reason,
      interest_rate: parseFloat(form.interest_rate),
      fixed_fee: form.fixed_fee,
      tax: form.tax,
      properties: form.properties,
      principal_amount: form.principal_amount,
      credit_start_date: form.credit_start_date,
      credit_end_date: form.credit_end_date,
      expense_amount: form.expense_amount,
      expense_payment_time: form.expense_payment_time,
      commission_amount: form.commission_amount,
      commission_payment_time: form.commission_payment_time,
      additional_maturity_days: form.additional_maturity_days
    })

    formData.append('json_body', body)

    return apiClient
      .postForm('/financing-cost-summary', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  export(financingCostSummaryId) {
    return apiClient
      .get('financing-cost-summary/' + financingCostSummaryId + '/export')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getFinancingCostSummaryActions(financingCostSummaryId, query) {
    return apiClient
      .get('financing-cost-summary/' + financingCostSummaryId + '/actions', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  addFinancingCostSummaryAction(form, financingCostSummaryId) {
    let formData = new FormData()
    formData.append('file', form.file)

    if (country.is('tr')) {
      formData.append('promissory_note_reason', form.reason_data.id)
      formData.append('action_date', moment(form.add_date))
    }

    return apiClient
      .postForm('/financing-cost-summary/' + financingCostSummaryId + '/add', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteFinancingCostSummaryAction(form, financingCostSummaryId) {
    let formData = new FormData()
    formData.append('file', form.file)

    if (country.is('tr')) {
      formData.append('promissory_note_reason', form.reason_data.id)
      formData.append('action_date', moment(form.delete_date))
      formData.append('financing_bank', form.financing_bank.id)
    }

    return apiClient
      .postForm('/financing-cost-summary/' + financingCostSummaryId + '/delete', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateFinancingCostSummary(id, data) {
    return apiClient
      .patch(`financing-cost-summary/${id}`, data)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  addCommission(id, data) {
    return apiClient
      .post(`financing-cost-summary/${id}/add-commission`, data)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  addExpense(id, data) {
    return apiClient
      .post(`financing-cost-summary/${id}/add-expense`, data)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updatePaymentStatus(id, data) {
    return apiClient
      .patch(`financing-cost-summary/${id}/update-payment-status`, data)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getDocuments(financingCostSummaryId) {
    return apiClient
      .get(`financing-cost-summary/${financingCostSummaryId}/documents`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  uploadDocument(financingCostSummaryId, data) {
    return apiClient
      .postForm(`financing-cost-summary/${financingCostSummaryId}/upload-document`, data)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  viewDocument(financingCostSummaryId, document) {
    return apiClient
      .get(`financing-cost-summary/${financingCostSummaryId}/documents/${document.id}`, {
        responseType: 'arraybuffer'
      })
      .then(response => {
        let blob = new Blob([response], { type: document.content_type })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  deleteDocument(financingCostSummaryId, documentId) {
    return apiClient
      .delete(`financing-cost-summary/${financingCostSummaryId}/documents/${documentId}`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  exportFinancingCostSummaries(query) {
    return apiClient
      .get('financing-cost-summary/export', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
